import React from 'react';
import PropTypes from 'prop-types';
import { ImageAsset } from '@spp/ui-image';
import moment from 'moment';
import classNames from 'classnames';

const assembleQueryParams = (params) =>
    Object.keys(params)
        .map((key) => `${key}=${encodeURIComponent(params[key])}`)
        .join('&');

const Teaser = ({ article, fullWidthDesktop, fullWidthMobile, theme, utmParams }) => {
    const {
        changes: { published: articlePublished } = '',
        links: { canonicalUrl: articleLink } = '',
        promotionContent: {
            imageAsset: { urls: imageUrls } = [],
            title: { value: articleTitle } = '',
        },
        customProperties: { vg_paywall: isPaywall = false } = {},
    } = article;

    const containerWidthPx = 980;
    const mobileImageWidth = fullWidthMobile ? '100vw' : '50vw';
    const desktopImageWidthPx = fullWidthDesktop
        ? containerWidthPx
        : Math.round(containerWidthPx / 3);
    const imageAsset = imageUrls ? (
        <ImageAsset
            urls={imageUrls}
            sizes={`(max-width: 980px) ${mobileImageWidth}, ${desktopImageWidthPx}px`}
            testTag={'@spp/ui-article-list:image-asset'}
        />
    ) : null;
    const indicator =
        isPaywall && imageAsset !== null ? (
            <div className={theme.plussIndicator} aria-label="VG-Pluss" />
        ) : null;

    const publishedDate = moment(articlePublished).format('DD.MM.YY');

    const className = classNames({
        [theme.articleCard]: true,
        [theme.fullWidthDesktop]: fullWidthDesktop,
        [theme.fullWidthMobile]: fullWidthMobile,
    });

    let href = articleLink;
    if (utmParams) {
        href += (href.indexOf('?') === -1 ? '?' : '&') + assembleQueryParams(utmParams);
    }

    return (
        <article className={className} itemScope itemType="https://schema.org/NewsArticle">
            <a href={href} itemProp="url">
                <div className={theme.imageWrapper}>
                    {imageAsset}
                    {indicator}
                </div>
                <h3 itemProp="headline">{articleTitle}</h3>
                <time itemProp="pubdate" dateTime={articlePublished}>
                    {publishedDate}
                </time>
            </a>
        </article>
    );
};

Teaser.propTypes = {
    article: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    utmParams: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    fullWidthDesktop: PropTypes.bool, // eslint-disable-line react/forbid-prop-types
    fullWidthMobile: PropTypes.bool, // eslint-disable-line react/forbid-prop-types
};

Teaser.defaultProps = {
    article: {},
    theme: {},
    fullWidthDesktop: false,
    fullWidthMobile: false,
};

export default Teaser;



/** WEBPACK FOOTER **
 ** ./src/local-components/article/Teaser.js
 **/